// NOTE: This is CJS so that it can be imported from next-i18next.config.js
module.exports = {
  defaultLocale: 'en',
  supportedLocales: ['en', 'de', 'es-419', 'fr', 'it', 'ko', 'pt-br']
}
